/*
 * @Author: your name
 * @Date: 2022-04-03 23:00:28
 * @LastEditTime: 2022-05-01 21:01:49
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishi-RCD\src\components\validate-code\index.js
 */
/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-04-03 21:22:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */
export default {
    data() {
      return {
        codes: [],
        ctx: "",
        colors: ["black", "black", "black", "black", "black", "black"],
        code_Len: 4
      };
    },
    created() {
      this.draw();
    },
    computed: {
      codeString() {
        let result = "";
        for (let i = 0; i < this.codes.length; i++) {
          result += this.codes[i];
        }
        return result.toUpperCase();
      }
    },
    watch: {
      codeString: function(newValue) {
        this.$emit("change", newValue);
      }
    },
    methods: {
      generateRandom() {
        this.codes = [];
        const chars = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        const charsArr = chars.split("");
   
        for (let i = 0; i < this.code_Len; i++) {
          const num = Math.floor(Math.random() * charsArr.length);
          this.codes.push(charsArr[num]);
        }
      },
      draw() {
        this.generateRandom();
        this.drawText();
      },
      drawLine() {
        const lineNumber = 2; // 线条条数
        const lineX = 140;
        const lineY = 30; // 最大线条坐标
        for (let i = 0; i < lineNumber; i++) {
          this.ctx.strokeStyle = this.colors[Math.floor(Math.random() * 5)];
          this.ctx.beginPath();
          this.ctx.moveTo(
            Math.floor(Math.random() * lineX),
            Math.floor(Math.random() * lineY)
          );
          this.ctx.lineTo(
            Math.floor(Math.random() * lineX),
            Math.floor(Math.random() * lineY)
          );
          this.ctx.stroke();
        }
      },
      drawText() {
        let that = this
        that.$nextTick(function() {
            const canvas = document.getElementById('canvas_1')
            that.ctx = canvas.getContext("2d");
        
            that.ctx.fillStyle = "#ffffff";
            that.ctx.fillRect(0, 0, 140, 40);
            that.ctx.font = "28px Verdana";
        
            let x = 15;
        
            for (let i = 0; i < that.code_Len; i++) {
                that.ctx.fillStyle = that.colors[Math.floor(Math.random() * 5)];
                that.ctx.fillText(that.codes[i], x, 25);
                x = x + 30;
            }
        
            that.drawLine();
        })
      }
    }
}